import React,{useState, useEffect} from 'react';
import {Link, useNavigate} from "react-router-dom";
import { FormControl, TextField, Typography, Box, IconButton, InputAdornment, OutlinedInput, InputLabel } from '@mui/material';
import logo from '../../Components/assets/images/logo.png';
import {toast } from 'react-toastify';
import { BaseUrl ,Signin } from '../../services/Url';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';


function Login(props){
	const navigate = useNavigate();
	const auth = localStorage.getItem('token');
	const [email, setEmail] = useState("");
	const [pwd, setPwd] = useState("");

	const submit = async (e) => {
		e.preventDefault();
		if(!email || !pwd){
			toast.error('Please enter your details')
		}else{
			fetch(`${BaseUrl + Signin}`,{
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ 
					"username" : email,
					"password" : pwd
				 })
			})
			.then(async response => {
				const data = await response.json();
				if (response?.status === 200) {
					localStorage.setItem('user', JSON.stringify(data));
					localStorage.setItem('token', data.data);
					toast.success(data.response);
					navigate('/');
				}else if(response?.status === 401){
					window.location.replace('/')
				}
				else if(response?.status === 404){
					toast.error('Please enter correct details');
				}
				else{
					toast.error(data.response);
				}
			})
			.catch(error => {
				toast.error(error);
			});
		}
	}

	useEffect(() => {
		if(auth){
			navigate('/');
		}
	}, [auth]);
	
	const [showPassword, setShowPassword] = React.useState(false);

	const handleClickShowPassword = () => setShowPassword((show) => !show);
  
	const handleMouseDownPassword = (event) => {
	  event.preventDefault();
	};
	
	return (
		<Box className='lgn_mdl_wpr'>
		<form
			onSubmit={submit}
			className="lgn_mdl"
			style={{

				width: " 500px ",
				margin: '0 auto',
				padding: "30px"
			}}
		>
			<Box>
			<div className='logo'>
				<img src={logo} alt='popular' loading='lazy'  />
			</div>
			<Typography variant='h4' marginBottom={4}>
			 Login
			</Typography>
			<Box display='flex' width='100%' flexDirection='column' gap={2} marginBottom={4}>
				<FormControl sx={{mb: 1}}>
                    <TextField	type='email'	label='Email' onChange={(e) => setEmail(e.target.value)}/>
				</FormControl>
				<FormControl variant="outlined">
						<InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
						<OutlinedInput
							id="outlined-adornment-password"
							type={showPassword ? 'text' : 'password'}
							onChange={(e) => setPwd(e.target.value)}
							endAdornment={
							<InputAdornment position="end">
								<IconButton
								aria-label="toggle password visibility"
								onClick={handleClickShowPassword}
								onMouseDown={handleMouseDownPassword}
								edge="end"
								>
								{showPassword ? <VisibilityOff /> : <Visibility />}
								</IconButton>
							</InputAdornment>
							}
							label="Password"
						/>
        		</FormControl>
				<Link  to="/forgotpassword" style={{color: 'red'}}>
					Forgot Password ?
				</Link>
			</Box>
			
			<Link  to="/" onClick={(e) => submit(e)} className='fluid_btn'>
				Login
			</Link>
			</Box>
		</form>
		</Box>
	);
}

export default Login;